export default class PowerUp {
    constructor(game, x, y, image, type) {
        this.game = game
        this.x = x
        this.y = y
        this.width = 100
        this.height = 100
        this.color = image
        this.type = type
        this.rotation = 0
        this.rotationFrequency = 0.02
        this.scale = 0.5
        this.image = document.getElementById(image)
        this.colisionRadius = this.width * this.scale / 2
        this.collisionOriginX = this.x + this.width * this.scale / 2
        this.collisionOriginY = (this.y + this.height * this.scale) - this.colisionRadius
        this.readyToDestroy = false
        this.missedItem = false
    }
    update(deltaTime) {
        this.x -= this.game.gameSpeed * deltaTime

        if(this.x + this.width < 0) {
            this.readyToDestroy = true
            this.missedItem = true
        }
        this.updateCollisionCircle()
    }
    draw(context) {
        context.globalAlpha = 1
        context.drawImage(this.image, 0, 0, this.width, this.height, this.x, this.y, this.width * this.scale, this.height * this.scale)
    }
    updateCollisionCircle() {
        this.colisionRadius = this.width * this.scale / 2
        this.collisionOriginX = this.x + this.width * this.scale / 2
        this.collisionOriginY = (this.y + this.height * this.scale) - this.colisionRadius
    }
}